<template>
    <div ref="Dom"></div>
</template>

<script setup>
import * as echarts from 'echarts';
import { defineProps, ref } from "vue";
import { onMounted, onUnmounted, watch } from "@vue/runtime-core";

const props = defineProps(['option'])
const Dom = ref(null);

var myChart = null
watch(() => {[props.option, Dom.value]}, () => {
    if (Dom.value && props.option && props.option.series && props.option.series.length > 0) {
        props.option.series.forEach(item => {
            if (item.type == 'pie' && item.data && item.data.length) {
                let show = {
                    show: true,
                }
                let hide = {
                    show: false
                }
                item.data.forEach((item) => {
                    if (item.value == 0) {
                        item['label'] = hide
                    } else {
                        item['label'] = show
                    }
                })
            }
        })

        myChart = echarts.init(Dom.value);
        myChart.setOption(props.option);
    }
}, { immediate: true, deep: true })
onMounted(() => {
    const observer = new ResizeObserver(() => {
        myChart.resize();
    })
    observer.observe(Dom.value)
})
onUnmounted(() => {
    myChart.dispose()
})

</script>
